import React from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import KATlogo from 'static/images/mvp/KATlogo.png';
import USDTlogo from 'static/images/mvp/USDTlogo.png';
import PAXGlogo from 'static/images/mvp/PAXGlogo.png';
import BNBlogo from 'static/images/mvp/BNBLogo.png';
import ETHlogo from 'static/images/mvp/ETHLogo.png';
import POLlogo from 'static/images/mvp/POLlogo.png';
import ZETAlogo from 'static/images/mvp/ZETAlogo.png';
import { Row, Col } from 'antd';
import { getKatUSDTQuote, getCedPackageById } from 'redux/actions/mvp/ced-package.action.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import { toast } from '../../../../../../node_modules/react-toastify/dist/index';
import { ToastContainer, toast } from "react-toastify";
import { I18n } from '../../../../../helpers/i18n';

class ConfirmationDialog extends React.Component {
  constructor(props) {
    super(props);
    // Khai báo state với các trường ban đầu
    this.state = {
      walletAddress: '', // Giữ địa chỉ ví
      UserChainId: 0, // Giữ chain ID
      infoStatus: '', // Giữ trạng thái thông tin
      infoNoti: '', // Giữ thông báo
      isConfirmButtonDisabled: true, // Trạng thái nút xác nhận
      katQuote: 0,
      usdtQuote: 0,
      paxgQuote: 0,
      bnbQuote: 0,
      ethQuote: 0,
      zetaQuote: 0,
      // Bạn có thể thêm các trường khác ở đây nếu cần
    };
  }
  getQuote = async () => {
    const { getKatUSDTQuote } = this.props;
    const quote = await getKatUSDTQuote()
    console.log("quote", quote)
    if (quote && quote.success && quote.data) {
      this.setState({
        katQuote: quote.data.katToUSD || 0,
        usdtQuote: quote.data.usdtToUSD || 0,
        paxgQuote: quote.data.paxgToUSD || 0,
        bnbQuote: quote.data.bnbToUSD || 0,
        ethQuote: quote.data.ethToUSD || 0,
        zetaQuote: quote.data.zetaToUSD || 0
      });
      if (this.props.paidCurrency === 'KAT') {
        if (
          this.state.katQuote &&
          quote.data.katToUSD &&
          this.formatPrice(this.props.paidAmountOnUSD / this.state.katQuote) !=
          this.formatPrice(this.props.paidAmountOnUSD / quote.data.katToUSD)
        ) {
        // if (quote.data.katToUSD > this.state.katQuote * 1.00000000001 || quote.data.katToUSD < this.state.katQuote * 0.00000000009) {
        toast.info(I18n.t('payment_package_exchange_rate_changed'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
      }
    } else if (this.props.paidCurrency === 'USDT') {
      console.log('quote.data.usdtToUSD', quote.data.usdtToUSD);
      console.log('this.state.usdtQuote', this.state.usdtQuote);
      if (
        this.state.usdtQuote &&
        quote.data.usdtToUSD &&
        this.formatPrice(this.props.paidAmountOnUSD / this.state.usdtQuote) !=
        this.formatPrice(this.props.paidAmountOnUSD / quote.data.usdtToUSD)
      ) {
        // if (quote.data.usdtToUSD > this.state.usdtQuote * 1.00000000001 || quote.data.usdtToUSD < this.state.usdtQuote * 0.00000000009) {
        // if (quote.data.usdtToUSD !== this.state.usdtQuote) {
        toast.info(I18n.t('payment_package_exchange_rate_changed'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
      }
    } else if (this.props.paidCurrency === 'PAXG') {
      if (
        this.state.paxgQuote &&
        quote.data.paxgToUSD &&
        this.formatPrice(this.props.paidAmountOnUSD / this.state.paxgQuote) !=
        this.formatPrice(this.props.paidAmountOnUSD / quote.data.paxgToUSD)
      ) {
        // if (quote.data.usdtToUSD > this.state.usdtQuote * 1.00000000001 || quote.data.usdtToUSD < this.state.usdtQuote * 0.00000000009) {
        // if (quote.data.usdtToUSD !== this.state.usdtQuote) {
        toast.info(I18n.t('payment_package_exchange_rate_changed'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
      }
    }
    else if (this.props.paidCurrency === 'BNB' || this.props.paidCurrency === 'POL') {
      if (
        this.state.bnbQuote &&
        quote.data.bnbToUSD &&
        this.formatPrice(this.props.paidAmountOnUSD / this.state.bnbQuote) !=
        this.formatPrice(this.props.paidAmountOnUSD / quote.data.bnbToUSD)
      ) {
        // if (quote.data.usdtToUSD > this.state.usdtQuote * 1.00000000001 || quote.data.usdtToUSD < this.state.usdtQuote * 0.00000000009) {
        // if (quote.data.usdtToUSD !== this.state.usdtQuote) {
        toast.info(I18n.t('payment_package_exchange_rate_changed'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
      }
    }
    else if (this.props.paidCurrency === 'ETH') {
      if (
        this.state.ethQuote &&
        quote.data.ethToUSD &&
        this.formatPrice(this.props.paidAmountOnUSD / this.state.ethQuote) !=
        this.formatPrice(this.props.paidAmountOnUSD / quote.data.ethToUSD)
      ) {
        // if (quote.data.usdtToUSD > this.state.usdtQuote * 1.00000000001 || quote.data.usdtToUSD < this.state.usdtQuote * 0.00000000009) {
        // if (quote.data.usdtToUSD !== this.state.usdtQuote) {
        toast.info(I18n.t('payment_package_exchange_rate_changed'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
      }
    }
    else if (this.props.paidCurrency === 'ZETA') {
      if (
        this.state.zetaQuote &&
        quote.data.zetaToUSD &&
        this.formatPrice(this.props.paidAmountOnUSD / this.state.zetaQuote) !=
        this.formatPrice(this.props.paidAmountOnUSD / quote.data.zetaToUSD)
      ) {
        toast.info(I18n.t('payment_package_exchange_rate_changed'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
      }
    }
    } else {
      console.error('Failed to fetch quotes:', quote?.error);
      // Keep existing state values if API call fails
    }
  }

  formatPrice = (price) => {
    if (price === null || price === undefined || isNaN(price)) {
      return '0';
    }
    const n = Number(price);
    if (!isFinite(n)) {
      return '0';
    }
    // Hiển thị tối đa 18 chữ số thập phân, tránh dạng e-notation
    // và loại bỏ các số 0 không cần thiết ở cuối
    return n
      .toFixed(18)
      .replace(/\.0+$/, '')
      .replace(/(\.\d*[1-9])0+$/, '$1');
  }

  componentDidMount = async () => {
    this.setState({
      katQuote: this.props.lastKATQuote,
      usdtQuote: this.props.lastUSDTQuote

    })
    const quote = await this.getQuote()
    this.setState(
      { isConfirmButtonDisabled: false })
    // Thiết lập interval để gọi hàm mỗi 10 giây
    this.quoteInterval = setInterval(() => {
      this.getQuote();
    }, 5000); // 10000 ms = 10 giây
  }
  componentWillUnmount() {
    // Dừng gọi hàm khi component bị gỡ bỏ
    clearInterval(this.quoteInterval);
  }

  handleYes = async () => {
    //await this.handlePayment()
    // Handle "Yes" confirmation
    const { onClose } = this.props;
    if (onClose) {
      if (this.props.paidCurrency === 'KAT') {
        onClose(this.state.katQuote); // Truyền tín hiệu "No" tới callback

      }
      else if (this.props.paidCurrency === 'USDT') {
        onClose(this.state.usdtQuote); // Truyền tín hiệu "No" tới callback

      }
      else if (this.props.paidCurrency === 'PAXG') {
        onClose(this.state.paxgQuote); // Truyền tín hiệu "No" tới callback
      }
      else if (this.props.paidCurrency === 'BNB') {
        onClose(this.state.bnbQuote); // Truyền tín hiệu "No" tới callback
      }
      else if (this.props.paidCurrency === 'POL') {
        onClose(this.state.bnbQuote); // Truyền tín hiệu "No" tới callback
      }
      else if (this.props.paidCurrency === 'ETH') {
        onClose(this.state.ethQuote); // Truyền tín hiệu "No" tới callback
      }
      else if (this.props.paidCurrency === 'ZETA') {
        onClose(this.state.zetaQuote); // Truyền tín hiệu "No" tới callback
      }
    }
  };

  handleNo = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose(""); // Truyền tín hiệu "No" tới callback
    }

  };

  render() {
    const {
      paidCurrency,
      paidAmountOnUSD,
      packageId,
      packageTitle,
      serviceRevShareAddress,
      chainID
    } = this.props;
    console.log("this.props.paidAmountOnUSD", this.state.bnbQuote)
    return (
      <div className="confirmation-background">

        <div className="confirmation-dialog">
          <div className="confirmation-dialog-content">

            <h1 className="confirmation-title">{I18n.t('payment_package_confirm')}</h1>
            <div container="true" spacing={1} className="transaction-details">
              <div className="bought-amount-title">
                {I18n.t('payment_package_confirm_using_with')}
                {'\u00A0'}
                <span style={{ fontWeight: 'bold' }}>{packageTitle}</span>
                {'\u00A0'}
                {I18n.t('payment_package_confirm_with')}
                {'\u00A0'}
                <span style={{ fontWeight: 'bold' }}>{paidCurrency}</span>
              </div>
              <div xs={12} sm={12} className="paid-amount-section">

                <div className="bought-amount-title">
                  {I18n.t('payment')}
                </div>

                <div className="box2" >
                  <Stack direction="row" spacing={1}>
                    {/* <Avatar>K</Avatar> */}
                    <img
                      style={{ width: '45px', height: '45px' }}
                      src={
                        this.props.paidCurrency === 'KAT' ? KATlogo :
                          this.props.paidCurrency === 'PAXG' ? PAXGlogo :
                            this.props.paidCurrency === 'BNB' ? BNBlogo :
                              this.props.paidCurrency === 'ETH' ? ETHlogo :
                                this.props.paidCurrency === 'POL' ? POLlogo :
                                  this.props.paidCurrency === 'ZETA' ? ZETAlogo :
                                    USDTlogo
                      }
                    />
                    <div className="kat2"> {this.props.paidCurrency}{'\u00A0'}
                      {
                        this.props.paidCurrency === 'KAT' ?
                          (this.state.katQuote ? this.formatPrice(this.props.paidAmountOnUSD / this.state.katQuote) : '0') :
                          this.props.paidCurrency === 'PAXG' ?
                            (this.state.paxgQuote ? this.formatPrice(this.props.paidAmountOnUSD / this.state.paxgQuote) : '0') :
                            this.props.paidCurrency === 'BNB' ?
                              (this.state.bnbQuote ? this.formatPrice(this.props.paidAmountOnUSD / this.state.bnbQuote) : '0') :
                              this.props.paidCurrency === 'POL' ?
                                (this.state.bnbQuote ? this.formatPrice(this.props.paidAmountOnUSD / this.state.bnbQuote) : '0') :
                                this.props.paidCurrency === 'ETH' ?
                                  (this.state.ethQuote ? this.formatPrice(this.props.paidAmountOnUSD / this.state.ethQuote) : '0') :
                                  this.props.paidCurrency === 'ZETA' ?
                                    (this.state.zetaQuote ? this.formatPrice(this.props.paidAmountOnUSD / this.state.zetaQuote) : '0') :
                                    (this.state.usdtQuote ? this.formatPrice(this.props.paidAmountOnUSD / this.state.usdtQuote) : '0')
                      }
                    </div>
                  </Stack>
                </div>
              </div>
              <div className="quote-info">
                {"*"}{I18n.t('exchange_rate', {money: this.props.paidCurrency, amount: this.props.paidCurrency === 'KAT' ?
                    this.formatPrice(this.state.katQuote || 0) :
                    this.props.paidCurrency === 'PAXG' ?
                      this.formatPrice(this.state.paxgQuote || 0) :
                      this.props.paidCurrency === 'BNB' ?
                        this.formatPrice(this.state.bnbQuote || 0) :
                        this.props.paidCurrency === 'POL' ?
                          this.formatPrice(this.state.bnbQuote || 0) :
                          this.props.paidCurrency === 'ETH' ?
                            this.formatPrice(this.state.ethQuote || 0) :
                            this.props.paidCurrency === 'ZETA' ?
                              this.formatPrice(this.state.zetaQuote || 0) :
                              this.formatPrice(this.state.usdtQuote || 0)})}
              </div>
            </div>
            <div className="confirmation-instructions">
              {/* <p className="loading-indicator">
                <CircularProgress className="CircularProgress" size={40} />
              </p> */}
              <p className="notifyingText">
                {this.state.infoNoti}
              </p>
              {/* <p className="notifyingText">
              Note: If the exchange rate at the time you confirm on MetaMask is more than 0.1% different from the current rate, the strike rate will be determined based on the rate at the time of confirming MetaMask transaction.
            </p>  */}
            </div>
            <div className="dialog-buttons-container">
              <Col>
                <Button className="done-button" onClick={this.handleYes} disabled={this.state.isConfirmButtonDisabled}>{I18n.t('confirm')}</Button>
              </Col>
              <Col>
                <Button className='button-cancle-mvp' onClick={this.handleNo}>{I18n.t('cancel')}</Button>
              </Col>
            </div>


          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getKatUSDTQuote,
  getCedPackageById
};
export default withRouter(connect(null, mapDispatchToProps)(ConfirmationDialog));
